import { LOGIN, LOGOUT, REFRESH_SUCCESS, REFRESH_FAILED } from 'config/actionTypes';
import { ADMIN_TOKEN_KEY } from 'config/constants';

const initialState = {
  loggedIn: false,
};

const authReducer = (
  state = initialState,
  {
    type,
    payload,
  }: {
    type: string;
    payload: ActionTypes.Auth.LoginActionPayload & ActionTypes.Auth.RefreshSuccessActionPayload;
  },
) => {
  switch (type) {
    case LOGIN:
      payload.token && localStorage.setItem(ADMIN_TOKEN_KEY, payload.token);
      return {
        ...state,
        loggedIn: true,
      };
    case LOGOUT:
      return {
        ...state,
        loggedIn: false,
      };
    case REFRESH_SUCCESS:
      payload && localStorage.setItem(ADMIN_TOKEN_KEY, payload);
      return {
        ...state,
        loggedIn: true,
      };
    case REFRESH_FAILED:
      return {
        ...state,
        loggedIn: false,
      };
    default:
      return state;
  }
};

export default authReducer;
